var map = {
	"./ar.svg": 1135,
	"./az.svg": 1136,
	"./bg.svg": 1137,
	"./bn.svg": 1138,
	"./ca.svg": 1139,
	"./cs.svg": 1140,
	"./da.svg": 1141,
	"./de.svg": 1142,
	"./el.svg": 1143,
	"./en.svg": 349,
	"./es.svg": 1144,
	"./es_CO.svg": 1145,
	"./et.svg": 1146,
	"./fa.svg": 1147,
	"./fi.svg": 1148,
	"./fr.svg": 1149,
	"./hi.svg": 1150,
	"./hu.svg": 1151,
	"./hy.svg": 1152,
	"./id.svg": 1153,
	"./is.svg": 1154,
	"./it.svg": 1155,
	"./ja.svg": 1156,
	"./ko.svg": 1157,
	"./lt.svg": 1158,
	"./mn.svg": 1159,
	"./nb.svg": 1160,
	"./nl.svg": 1161,
	"./pl.svg": 1162,
	"./pt.svg": 1163,
	"./pt_BR.svg": 1164,
	"./ro.svg": 1165,
	"./ru.svg": 1166,
	"./sk.svg": 1167,
	"./sl.svg": 1168,
	"./sq.svg": 1169,
	"./sr.svg": 1170,
	"./sv.svg": 1171,
	"./th.svg": 1172,
	"./tr.svg": 1173,
	"./uk.svg": 1174,
	"./vi.svg": 1175,
	"./zh-Hans.svg": 1176,
	"./zh-Hant.svg": 1177
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1134;